import React from 'react'
import Image from '../Image'
import { string, bool } from 'prop-types'
import { Text } from 'rebass'
import typography from '../../utils/typography'
import {
  Summary,
  VehicleModelHeaderSummary,
  VehicleModelHeader,
  Make,
  Title,
  SubTitle,
  Callout
} from './components/Hero'

class ContentBrandHero extends React.PureComponent {
  render() {
    const { calloutImage, calloutLink } = this.props
    return (
      <VehicleModelHeader
        role="banner"
        width={12 / 12}
        pt={[typography.rhythm(1), '10vh']}
        pb={[typography.rhythm(1), '5vh']}
        dark={this.props.dark}
        light={this.props.light}
        deep={this.props.deep}
        bg={this.props.bg}
      >
        <VehicleModelHeaderSummary
          width={[12 / 12, 11 / 12, 10 / 12]}
          mx="auto"
          compact={this.props.compact}
        >
          {this.props.make !== '' && (
            <Make dark={this.props.dark} f={[1, 2]} caps>
              {this.props.make}
            </Make>
          )}

          <Title
            as="h2"
            color="#ffffff"
            fontSize={[6, 7, 8]}
            px={'5%'}
            pb={[typography.rhythm(1), null, typography.rhythm(2)]}
            dangerouslySetInnerHTML={{ __html: this.props.title }}
          />

          <SubTitle as="h3" f={[4, 5, 6]} color="#ffffff">
            {this.props.price}
          </SubTitle>

          {this.props.children}

          {this.props.img && (
            <Image
              resource={this.props.img}
              alt={`${this.props.make} ${this.props.title}`}
              width="630"
              mode="pad"
            />
          )}
          {this.props.img && calloutImage && (
            <Callout href={calloutLink} alt="Callout Image Model">
              <Image
                resource={calloutImage}
                width="200"
                height="200"
                mode="pad"
              />
            </Callout>
          )}

          {this.props.summary !== '' && (
            <Summary
              dark={this.props.dark}
              mx={[0, null, 'auto']}
              px={['16px', null, '8%']}
              pb={[typography.rhythm(1), typography.rhythm(1)]}
            >
              <Text
                as="div"
                center
                dangerouslySetInnerHTML={{ __html: this.props.summary }}
              />
            </Summary>
          )}
        </VehicleModelHeaderSummary>
      </VehicleModelHeader>
    )
  }
}

ContentBrandHero.defaultProps = {
  title: 'no title',
  summary: '',
  bg: '',
  img: '',
  make: '',
  dark: false,
  light: false,
  compact: false,
  deep: false,
  price: ''
}
ContentBrandHero.propTypes = {
  title: string,
  summary: string,
  bg: string,
  img: string,
  make: string,
  dark: bool,
  light: bool,
  compact: bool,
  deep: bool,
  price: string,
  calloutImage: string,
  calloutLink: string
}

export default ContentBrandHero
